import { Link } from "react-router-dom";
import { Button, Img, Text, Heading } from "../../components";
import React from "react";

export default function WhyChooseUsSection() {
  return (
    <>
      {/* Why Choose Us Section */}
      <div className="flex flex-col items-center bg-[url(/public/images/img_frame_313693.webp)] bg-cover bg-no-repeat py-[134px] md:py-[60px] sm:py-5">
        <div className="container-xs flex flex-col items-start px-2 md:px-[30px] sm:px-4 gap-6">
          {/* Section Title */}
          <Text size="text10xl" as="p" className="font-normal text-muted sm:text-[18px]">
            Why choose us?
          </Text>
          <Heading
            size="heading8xl"
            as="h2"
            className="w-[80%] font-medium leading-[60px] text-dark md:w-full md:text-[42px] sm:text-[24px] sm:leading-[10px]"
          >
            <span>Achieve real results with </span>
            <span className="font-bold">precision-engineered & AI-enabled solutions</span>
          </Heading>

          {/* Feature List */}
          <div className="flex flex-col gap-6 mt-6 w-full">
            {[
              "Monitor real-time data from all connected machines.",
              "Simulate operational scenarios for predictive maintenance.",
              "Visualize plant processes with interactive 3D models.",
              "Track and analyze equipment performance and efficiency.",
              "Optimize workflows with AI-driven operational insights.",
              "Receive instant alerts for system anomalies and failures.",
            ].map((text, index) => (
              <div key={index} className="flex items-center gap-4">
                <Img
                  src="images/img_frame_358.svg"
                  alt={`Feature ${index + 1}`}
                  className="h-[58px] w-[58px] object-contain sm:h-[25px] sm:w-[25px]"
                />
                <Text
                  size="text8xl"
                  as="p"
                  className="font-medium text-blue_gray-500 md:text-[24px] sm:text-[20px]"
                >
                  {text}
                </Text>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <Link
              to="/solutions"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
            <Button
              size="3xl"
              rightIcon={
                <Img
                  src="images/img_externallink.svg"
                  alt="External-link"
                  className="my-0.5 h-[26px] w-[26px] object-contain"
                />
              }
              className="mt-8 min-w-[216px] gap-4 rounded-md px-[26px] font-bold !text-white shadow-sm sm:px-5"
            >
              
                Learn More
            </Button>
          </Link>            
        </div>
      </div>
    </>
  );
}
